__turbopack_context__.v({
  "button": "youtube1440px-module-scss-module__TSDgOG__button",
  "button1": "youtube1440px-module-scss-module__TSDgOG__button1",
  "container": "youtube1440px-module-scss-module__TSDgOG__container",
  "content": "youtube1440px-module-scss-module__TSDgOG__content",
  "icontext": "youtube1440px-module-scss-module__TSDgOG__icontext",
  "mdiyoutubeIcon": "youtube1440px-module-scss-module__TSDgOG__mdiyoutubeIcon",
  "seeAFewFleet": "youtube1440px-module-scss-module__TSDgOG__seeAFewFleet",
  "title": "youtube1440px-module-scss-module__TSDgOG__title",
  "youtube1440px": "youtube1440px-module-scss-module__TSDgOG__youtube1440px",
});
